import React from "react";
import "./Section1.css";
import GirlsImage from "../../../../../assets/images/taxplaningsr-sec1img.png";
import Trianble from "../../../../../assets/images/taxplaningsr-sec1shape1.png";
const Section1 = () => {
  return (
    <div className="taxplanning__service_section1">
      <img
        src={Trianble}
        alt=""
        className="taxplanningsr____section_triangle"
      />
      <div className="taxplanningsr____section_left">
        <div className="taxplanningsr____secleft_description">
          <p>
            Tax preparation does not come easy even when it comes to filing a
            simple return. With Serene Tax , you will benefit in learning that
            with our expertise, we do not let you miss out on deductions and
            credits which you are entitled and are allowed by the tax code.
          </p>
          <p>
            Tax Planning is critical to a healthy financial life. Certain tax
            impacts and substantial tax considerations are important and we can
            help protect the assets you transfer from excessive depletion by
            understanding these taxes and the various strategies to help you
            minimize them.
          </p>
          <p>
            Your tax return will be checked and rechecked by our computer
            software identifying potential problems the IRS may look at more
            closely and reviewing the math to limit IRS contacts.
          </p>
        </div>
      </div>
      <div className="taxplanningsr____section_right">
        <img src={GirlsImage} alt="" className="taxplanningsr____section_img" />
      </div>
    </div>
  );
};

export default Section1;
